<template>
  <v-card width="100%" outlined>
    <v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline mb-4">
          Dashboard
        </div>
        <v-list-item-title class="text-h5 mb-1">
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle>{{ code }}</v-list-item-subtitle>
      </v-list-item-content>

      <!-- <v-list-item-avatar tile size="80" color="grey"> -->
      <v-icon size="40">{{ icons(code) }}</v-icon>
      <!-- </v-list-item-avatar> -->
    </v-list-item>

    <v-card-actions>
      <v-btn outlined text @click="goToDashboard()">
        Go to Dashboard
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    code: String,
    link: String,
    domain : String
  },

  methods: {
    goToDashboard() {
      console.log('domain', this.$props)
      window.open(`${this.$props.domain}/sso/${this.getToken}?link=${this.$props.link}&code=${this.$props.code}&redirect=${this.$props.domain}/${this.$props.link}`, '_blank');
    },

    icons(type) {
      switch (type) {
        case "finance_acquisition":
          return "mdi-finance";
        case "cod_dashboard":
          return "mdi-account-clock-outline";
        case "pds":
          return "mdi-lan-disconnect";
        case "admin_acquisition":
          return "mdi-shield-crown-outline";
        default:
          return "mdi-view-dashboard-outline";
      }
    },
  },

  computed: {
    getToken() {
      return this.$store.getters.token || "";
    },
  },
};
</script>
